
import {
  defineComponent, onMounted, onUnmounted, PropType, ref, Ref,
} from 'vue';
import { IMedia, ITemporaryFile } from '@/types/interfaces';
import { useDriveStore } from '../../store/driveStore';
import DriveUiWrapper from './DriveUIWrapper.vue';
import { HIDE_BORDER, MEDIA_TYPES, PHOTO_VIEW_TYPE } from '@/types/enums';
import { lowResUrlByViewType } from '@/helpers/lowResPhotoUrl';
import AppSkeletonRect from '@/components/skeletons/AppSkeletonRect.vue';

export default defineComponent({
  props: {
    temporaryFiles: { type: Array as PropType<ITemporaryFile[]>, required: true },
    title: { type: String, required: true },
    isPhoto: { type: Boolean, default: false },
    hideBorder: { type: Number as () => HIDE_BORDER, default: HIDE_BORDER.NONE },
    skeletonAmount: { type: Number, default: 0 },
  },
  components: {
    DriveUiWrapper,
    AppSkeletonRect,
  },
  emits: ['openUploadPopUp', 'removeFile'],
  setup(props, { emit }) {
    const driveStore = useDriveStore();

    const fileInputButton: Ref<HTMLElement | null> = ref(null);

    const itemHeight: Ref<string> = ref('');
    const itemMargin: Ref<string> = ref('');

    function onResize() {
      if (props.isPhoto && fileInputButton.value) {
        itemHeight.value = `${fileInputButton.value!.offsetWidth}px`;
        itemMargin.value = `${(fileInputButton.value!.offsetWidth * 5) / 21.25}px`;
      } else {
        itemHeight.value = `${fileInputButton.value!.offsetWidth}px`;
        itemMargin.value = `${(fileInputButton.value!.offsetWidth * 5) / 21.25}px`;
      }
    }

    function openPopUp(event) {
      emit('openUploadPopUp', { x: event.clientX - 386, y: event.clientY - 80 });
    }

    function removeFile(tempFile: ITemporaryFile) {
      emit('removeFile', tempFile);
    }

    function resolvePhoto(photo: IMedia) {
      if (photo.type === MEDIA_TYPES.PHOTO) {
        return lowResUrlByViewType(photo, PHOTO_VIEW_TYPE.WHSML);
      }
      return process.env.VUE_APP_MEDIA_URL + photo.previewUrl;
    }

    onMounted(() => {
      window.addEventListener('resize', onResize);
      onResize();
    });

    onUnmounted(() => {
      window.removeEventListener('resize', onResize);
    });

    return {
      fileInputButton,
      itemHeight,
      itemMargin,
      driveStore,
      resolvePhoto,
      openPopUp,
      removeFile,
      MEDIA_TYPES,
    };
  },
});
